// Helper function to return link type and url
const LinkSearchReplace = (text) => {
    let newText = text.replace(/cms./g, "")
    newText = newText.replace(/staging./g, "")
    return newText
}

export { LinkSearchReplace }